"use client";

import { StageBadge } from "@/features/jobs/components/stage-badge";

interface StageCellProps {
  name?: string | null;
  color?: string | null;
}

export function StageCell({ name, color }: StageCellProps) {
  return <StageBadge name={name} color={color} />;
}
